import { VSInstanceInfo } from "../store/appState";
import { SettingsUpdate } from "../SettingsUpdate";
import { FileUploadConfig } from "../DataCollectorConfiguration";
import { AssemblyFileNames } from "../Settings";

export interface PlatformActions {
    get(authRequired: boolean, partialUri: string): Promise<any>;
    post(authRequired: boolean, partialUri: string, data: any): Promise<any>;

    signOutAndIn(): Promise<UserInfo>;
    signOut(): Promise<void>;
    checkForSignIn(): Promise<Accounts | UserInfo | null>;

    getNativeActions(): NativeActions | null;
    getLocalServerActions(): LocalServerActions | null;
}

export interface LocalServerActions {
    get(authRequired: boolean, partialUri: string): Promise<any>;
    post(authRequired: boolean, partialUri: string, data: any): Promise<any>;
}

export interface NativeActions {
    newVsInstance(): Promise<void>;
    getRunningVsInstances(): Promise<VSInstanceInfo[]>;
    updateSettings(vsPid: number): Promise<SettingsUpdate>;
    startCollectDiagnostics(processId: number, additionalProcessIds: number[], diagSessionId: number): Promise<void>;

    /** Stops the diagnostics collection. Only supported for native process where useWebRecording is true */
    stopCollectDiagnostics(): Promise<void>;

    viewFile(filePath: string): Promise<void>;
    getScreenshot(thumbnail: boolean): Promise<ImageInfo>;
    selectFiles(): Promise<FileSelection>;
    startUploadingFiles(config: FileUploadConfig, screenshot?: ScreenshotCropConfig): Promise<void>;
    reserveNewTrackingId(): Promise<TrackingIdInfo>;
    chooseAccount(vsid: string): Promise<void>;
}

/** Used for differentiating account type and links for MeControlV2 */
export enum AccountType {
    aad = "aad", // Enterprise customer account (Azure Active Directory), e.g. @microsoft.com emails
    msa = "msa", // Consumer microsoft account (e.g. @outlook.com email)
    ghb = "ghb", // Some @outlook.com accounts also show this
}

export interface UserInfoNoLogo {
    vsid: string; // "1798b88c-c4a0-4aa7-85f1-e97eee80d9c3"
    name: string; // "Nikola Mihaylov"
    email: string; // "test@outlook.com"
    providerId?: AccountType; // "aad", "msa", "ghb", maybe others. Can be null
    stale: boolean; // false, true if expired
}

export interface Accounts {
    users: UserInfo[];
}

export interface UserInfo extends UserInfoNoLogo {
    logo?: string; // base-64 encoded jpg/png
}

export interface ImageInfo {
    dataUrl: string; // base64 encoded data url of an image, if any; can be assigned directly to img.src in HTML
    width: number;
    height: number;
}

export interface FileSelection {
    includedFilePaths: string[]; // files that the user selected and allowed by the upload policies
    deniedFilePaths: string[]; // files that the user selected, but are not allowed since considered malicious (.exe, .dll, etc.)
}

export interface RemoteLogs {
    // @TODO: Update this if needed once native side work is done
    filesToUploadPerAssembly: AssemblyFileNames[] | null; // list of additional files to upload, if any
    recordingFilesToUpload: string[] | null; // list of recording file paths
}

export interface ScreenshotCropConfig {
    useThumbnailCropDimensions: boolean; // true if crop rect refers to thumbnail, false otherwise
    crop?: CropSizedRect; // crop rect or null to include full screenshot
}

export interface CropSizedRect {
    left: number;
    top: number;
    width: number;
    height: number;
}

/** Used by `reserveNewTrackingId` command */
export interface TrackingIdInfo {
    trackingId: string;
}